export const TEST_ID = 'searchDrawerResultsRegion';
